//
//
//
//
//
//
//

import Alignable from "../../mixins/Alignable";

export default {
    name: "Wrapper",

    mixins: [Alignable],

    props: {

        // The column name on which to break the content
        breakColumn: {
            type: String,
            default: null
        },

        // Whether to reverse the element order on break
        breakReverse: {
            type: Boolean,
            default: false
        },

        // Whether to align the items with 'justify-between'
        between: {
            type: Boolean,
            default: false
        },

        // Whether the content shall take the full parent's width up to a max width of 300px for each item
        grow: {
            type: Boolean,
            default: false
        },

        // Whether the content shall take the full parent's width without an individual width limit
        stretch: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        column() {
            switch (this.breakColumn) {
                case 'xs':
                    return this.$breakpoint.xsOnly;
                case 'sm':
                    return this.$breakpoint.smAndDown;
                case 'md':
                    return this.$breakpoint.mdAndDown;
                case 'lg':
                    return this.$breakpoint.lgAndDown;
                case 'xl':
                    return this.$breakpoint.xlOnly;
            }
            return false
        }
    }
}
